/**
 * Indicates that IOI is the result of an existing agency order or a facilitation position resulting from an agency order, not from principal trading or order solicitation activity.
 * tag: 130
 * @readonly
 * @enum {string} (Boolean)
 */
export enum IOINaturalFlag {
  /** Not Natural */
  NotNatural = 'N',
  /** Natural */
  Natural = 'Y',
}
